'use strict';

(function() {
    var util = angular.module('gymsystem.util');

    util.factory('payment', ['live', '$q', '$modal', function(live, $q, $modal) {
        var payment = {};

        payment.showTrainingCardPayments = function(card) {
            $modal.open({
                templateUrl: 'components/payment/paymentlist.html',
                controller: 'TrainingCardPayments',
                windowClass: 'huge-modal-window',
                resolve: {
                    trainingCard: function() {
                        return card;
                    }
                }
            });
        };

        payment.waitPayment = function(pendingId, $scope) {
            var deferred = $q.defer();
            var unsubscribe = live.subscribe({
                type: 'pendingdirectpayment',
                scope: $scope,
                callback: function(pdp) {
                    if(pdp.id === pendingId) {
                        unsubscribe();
                        if(pdp.paid) {
                            deferred.resolve(pdp);
                        } else if(pdp.failed) {
                            deferred.reject(pdp);
                        }
                    }
                }
            });
            return deferred.promise;
        };

        payment.bamboraDialog = function(option) {
            var deferred = $q.defer();
            $modal.open({
                templateUrl: 'components/payment/bamboradialog.html',
                controller: 'BamboraDialogCtrl',
                resolve: {
                    dialogOption: function() {
                        option.deferred = deferred;
                        return option;
                    }
                },
                backdrop: 'static',
                keyboard: false
            });
            return deferred.promise;
        };

        payment.adyenTerminal = (options) => {
            return new Promise((resolve, reject) => {
                $modal.open({
                    templateUrl: 'components/payment/adyen-terminal/adyen-terminal.html',
                    controller: 'AdyenTerminalCtrl',
                    resolve: {
                        options: function() {
                            return {...options, resolve, reject};
                        }
                    },
                    backdrop: 'static',
                    keyboard: false
                });
            });
        };

         /**
         * Determines how much has already been paid for a given payment.
         *
         * @param {Object} payment - The payment object.
         * @returns {number} The amount that has already been paid.
         */
         payment.getAlreadyPaid = (payment) => {
            if (payment.invoiceNumber) {
                let sum = 0;
                payment.transactions?.forEach((t) => {
                    if (!t.claim) {
                        sum += Number(t.amount);
                    }
                });

                return sum;
            } else if (payment.status == 'paid') {
                return payment.totalamount;
            }

            return 0;
        };

        payment.getCreditedAmount = (payment) => {
            let sum = 0;
            payment.parts?.forEach((part) => {
                if (part.status == 'credited') {
                    sum += Number(part.amount);
                }
            });

            return sum;
        }

        /**
         * Calculates debts based on a list of payments.
         *
         * @param {Array} payments - An array of payment objects.
         * @param {Object} customer - The current customer object.
         * @returns {Array} An array of debt objects.
         */
        payment.getDebtsList = function(payments, customer) {
            if (!payments || !customer) {
                return [];
            }

            // A Set to keep track of processed transaction IDs as related payments may contain the same transactions.
            const processedTransactions = new Set();

            /**
             * Determines how much has already been paid for a given payment.
             *
             * @param {Object} payment - The payment object.
             * @returns {number} The amount that has already been paid.
             */
            function getAlreadyPaid(payment) {
                if (payment.status === 'paid') {
                    return Number(payment.amount);
                }

                if (payment.invoiceNumber && payment.transactions) {
                    let sum = 0;
                    payment.transactions.forEach(transaction => {
                        if (!transaction.claim && !processedTransactions.has(transaction.id)) {
                            processedTransactions.add(transaction.id);
                            sum += Number(transaction.invoice_part) + Number(transaction.invoice_extra);
                        }
                    });
                    return sum;
                }
                return 0;
            }

            /**
             * Processes the payments and calculates debts.
             *
             * Debts are adjusted by subtracting any already-paid amounts.
             * The amount for credited payments is negative and is therefore automatically subtracted from the total debt.
             *
             * @returns {Array} An array of debt objects. Debt objects contain the following properties: { amount, payer, customer }
             */
            function getDebts() {
                processedTransactions.clear();

                // Filter payments that are still pending, failed, sent or marked for inkasso(debt collection).
                // Failed payments are processed regardless of date.
                const unpaidPayments = payments.filter(payment => {
                    const isPaymentUnresolved = ['pending', 'failed', 'sent', 'inkasso'].includes(payment.status);
                    const isValidDate = !payment.date.isFutureDate() || payment.status == 'failed';
                    return isPaymentUnresolved && isValidDate;
                });

                // Object to accumulate debts keyed by the relevant party's id.
                const debts = {};

                unpaidPayments.forEach(payment => {
                    const isPayingForSomeoneElse = payment.payer_id == customer.id;
                    const isOwnPayment =  payment.user_id == customer.id;

                    if (!isOwnPayment && !isPayingForSomeoneElse) {
                        return;
                    }

                    const key = isPayingForSomeoneElse ? payment.user_id : payment.payer_id;

                    if (!debts[key]) {
                        debts[key] = { amount: 0, payer: payment.payer, customer: payment.user };
                    }

                    debts[key].amount += Number(payment.amount) - getAlreadyPaid(payment);
                });

                return Object.values(debts);
            }

            return getDebts();
        }

        return payment;
    }]);

    util.controller('BamboraDialogCtrl', ['$scope', 'dialogOption', 'live', 'server', 'alertProvider', function($scope, dialogOption, live, server, alertProvider) {
        var pendingId = dialogOption.pendingId;
        var controlKey = dialogOption.controlKey;
        $scope.selfCheckout = dialogOption.selfCheckout;
        var cashRegister = dialogOption.cashRegister;

        var promiseDone = false;
        $scope.status = 'loading';
        $scope.statusText = 'Connecting to terminal';
        $scope.controlReady = false;
        $scope.dialog = null;
        $scope.canReversal = false;
        var saleAccepted = false;
        var networkError = false;
        var networkHadError = false;
        var reprinting = null;
        var retrying = null;
        var cancelled = false;
        var opened = Date.now();

        $scope.preventFromClosing = false;
        $scope.close = function() {
            if(!$scope.preventFromClosing) {
                $scope.$dismiss();
            }
        };

        function getTerminalStatusText(cr) {
            if (cr.terminal_status == 'works') {
                if (controlKey != cr.terminal_control_key) {
                    return 'Terminal is busy';
                }
            }

            return {
                noapp: 'App is not started',
                noterminal: 'Terminal connection error',
                unknown: 'Unknown connection error'
            }[cr.terminal_status];
        }

        $scope.isConnecting = function() {
            return $scope.statusText == 'Connecting to terminal';
        };

        $scope.control_key = controlKey;

        $scope.terminal_control_key = cashRegister.terminal_control_key;
        $scope.terminalStatusText = getTerminalStatusText(cashRegister);
        live.subscribe({
            type: 'cashregister',
            scope: $scope,
            action: 'change',
            callback: function(cr) {
                if (cr.id == cashRegister.id) {
                    $scope.terminalStatusText = getTerminalStatusText(cr);
                    $scope.terminal_control_key = cr.terminal_control_key;
                }
            }
        });

        live.subscribe({
            type: 'staff_event',
            scope: $scope,
            action: controlKey,
            callback: function(msg) {
                var data = msg.data;

                if(!$scope.controlReady) {
                    if(Date.now() - opened < 2000 && data.type != 'control_ready') {return;}
                    $scope.controlReady = true;
                    if(!cancelled) {
                        live.sendToChannel(controlKey, {cmd: 'ready'});
                        $scope.preventFromClosing = true;
                    }
                }
                if(data.type == 'dialog') {
                    $scope.dialog = {
                        type: 'dialog',
                        //id: data.value.id,
                        //id_text: data.value.id_text,
                        title: data.value.title,
                        //product_name: data.value.product_name,
                        text: data.value.text
                    };
                    if (data.value.product_name) {
                        $scope.product_name = data.value.product_name;
                    }
                } else if(data.type == 'network_error') {
                    networkError = true;
                    networkHadError = true;
                    $scope.statusText = 'Network problem, the terminal is unavailable';
                } else if(data.type == 'network_up') {
                    networkError = false;
                    $scope.statusText = 'Processing';
                } else if(data.type == 'payment_success') {
                    $scope.preventFromClosing = true;
                    $scope.statusText = 'Payment was successful, checkout is finishing';
                } else if(data.type == 'no_connection') {
                    $scope.statusText = 'Unable to connect to a terminal';
                } else if(data.type == 'connected') {
                    $scope.statusText = 'Processing';
                } else if(data.type == 'checkout_error') {
                    $scope.statusText = 'Payment was successful, but checkout contains errors';
                } else if(data.type == 'error') {
                    $scope.statusText = 'Processing error';
                } else if(data.type == 'retry_fail') {
                    retrying = null;
                } else if(data.type == 'retry_success') {
                    retrying = null;
                } else if(data.type == 'reprint_fail') {
                    reprinting = null;
                    alertProvider.show('error', 'Reprint was failed');
                } else if(data.type == 'reprint_success') {
                    reprinting = null;
                    alertProvider.show('success', 'Reprinted successfully');
                } else if(data.type == 'sale_accepted') {
                    saleAccepted = true;
                    $scope.statusText = 'Processing';
                } else if(data.type == 'reversal_success') {
                    $scope.canReversal = true;
                    alertProvider.show('success', 'Reversal finished');
                } else if(data.type == 'reversal_fail') {
                    $scope.canReversal = true;
                    alertProvider.show('error', 'Reversal was failed');
                } else if(data.type == 'transaction_finished') {
                    $scope.preventFromClosing = false;
                }

                if(data.status == 'success' || data.status == 'fail') {
                    $scope.preventFromClosing = false;
                    $scope.status = data.status;
                    promiseDone = true;
                    if(data.status == 'success') {
                        $scope.statusText = 'Success';
                        dialogOption.deferred.resolve({
                            ccu_bandle_id: data.ccu_bandle_id
                        });
                    } else {
                        $scope.statusText = 'Fail';
                        dialogOption.deferred.reject();
                    }

                    if(dialogOption.autoclose) {
                        setTimeout($scope.close, dialogOption.autoclose === true? 0 : dialogOption.autoclose);
                    }
                }

                if(data.allow_reversal) {
                    $scope.canReversal = true;
                }
                $scope.$apply();
            }
        });

        var active = true;
        $scope.$on('$destroy', function() {
            active = false;
            live.sendToChannel(controlKey, {cmd: 'close'});
            if(!promiseDone) {
                promiseDone = true;
                dialogOption.deferred.reject();
            }

            if(!saleAccepted) {
                server.post2('/api/payment/bambora/cancel', {'pending_id': pendingId});
            }
        });

        function sendPing() {
            if(!active) {return;}
            setTimeout(sendPing, 15000);
            live.sendToChannel(controlKey, {cmd: 'ping'});
        }
        setTimeout(sendPing, 15000);

        $scope.canCancel = function() {
            return !cancelled && !networkError && $scope.status == 'loading';
        };
        $scope.cancel = function() {
            cancelled = true;
            if(!networkError) {
                live.sendToChannel(controlKey, {cmd: 'cancel'});
            }

            if ($scope.isConnecting()) {
                $scope.close();
            }
        };

        $scope.canToRetry = function() {
            return !retrying && !reprinting && networkHadError;
        };
        $scope.retry = function() {
            if(retrying) {
                clearTimeout(retrying);
            }
            retrying = setTimeout(function() {
                retrying = null;
                $scope.$apply();
            }, 10000);

            live.sendToChannel(controlKey, {
                cmd: 'retry',
                pending_id: pendingId
            });
        };

        $scope.canReprint = function() {
            return !reprinting && !retrying && $scope.status != 'loading';
        };
        $scope.reprintReceipt = function() {
            if(reprinting) {
                clearTimeout(reprinting);
            }
            reprinting = setTimeout(function() {
                reprinting = null;
                $scope.$apply();
            }, 10000);

            live.sendToChannel(controlKey, {
                cmd: 'reprint',
                pending_id: pendingId
            });
        };

        $scope.reversal = function() {
            $scope.canReversal = false;
            setTimeout(function() {
                $scope.canReversal = true;
                $scope.$apply();
            }, 10000);

            live.sendToChannel(controlKey, {
                cmd: 'reversal',
                pending_id: pendingId
            });
        };

    }]);
})();
